import { useState, useEffect } from "react";

const InputField = ({
  formik,
  name = "text",
  type = "text",
  placeholder = "Champs de saisie",
  autoComplete = "off",
  className = "w-full bg-white/20 text-white placeholder-gray-400 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-white",
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isPassword = type === "password";

  // useEffect(() => {
  //     if (defaultValue && !formik.values[name]) {
  //         formik.setFieldValue(name, defaultValue);
  //     }
  // }, [defaultValue, formik, name]);

  return (
    <div className="space-y-1">
      <div className="relative">
        <input
          type={isPassword && showPassword ? "text" : type}
          name={name}
          placeholder={placeholder}
          autoComplete={autoComplete}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values[name]}
          className={` ${className}`}
        />
        {isPassword && (
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            className="absolute right-3 top-2 text-sm text-gray-500"
          >
            {showPassword ? "Cacher" : "Afficher"}
          </button>
        )}
      </div>
      {formik.touched[name] && formik.errors[name] && (
        <p className="text-red-400 text-sm">{formik.errors[name]}</p>
      )}
    </div>
  );
};

export default InputField;
